import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Third.svg';
import { DownloadButton } from '@/components/buttons';
import { OldDocumentsToggle } from '@/sections/documents/OldDocumentsToggle';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { Text } from '@/components/typography';
export function PayInThreeConditions(props) {
  const $ = _c(56);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["termsAndConditions"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.2.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconThird className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("categories.2.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("categories.2.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("categories.2.list.1");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <li>{t7}</li>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("categories.2.list.2");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <li>{t9}</li>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("categories.2.list.3");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li>{t11}</li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("categories.2.list.4");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <li>{t13}</li>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("categories.2.list.5");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <li>{t15}</li>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t14 || $[35] !== t16 || $[36] !== t8) {
    t17 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500 lg:mb-12">{t8}{t10}{t12}{t14}{t16}</ul>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t14;
    $[35] = t16;
    $[36] = t8;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== locale) {
    t18 = FILES(locale);
    $[38] = locale;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = t18.termsAndConditionsPayInThree;
  let t20;
  if ($[40] !== t) {
    t20 = t("categories.2.documents.current");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t18.termsAndConditionsPayInThree || $[43] !== t20) {
    t21 = <DownloadButton to={t19} testId="termsAndConditionsPayInThreeCurrent" analyticsParam="termsAndConditionsPayInThreeCurrent">{t20}</DownloadButton>;
    $[42] = t18.termsAndConditionsPayInThree;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== locale || $[46] !== t) {
    t22 = !!FILES(locale).oldTermsAndConditionsPayInThree.length && <div className="mt-4"><OldDocumentsToggle closedTitle={t("show")} openedTitle={t("hide")}>{FILES(locale).oldTermsAndConditionsPayInThree.map(t23 => {
          const {
            path,
            date,
            customLabel
          } = t23;
          return <div className="mb-2 lg:mb-4" key={path}><DownloadButton to={path} testId="termsAndConditionsOld" analyticsParam="termsAndConditionsOld" variant="old" className="sm:w-full">{customLabel ? <Text as="p" variant="p3">{customLabel}</Text> : <Trans t={t} i18nKey="categories.2.documents.oldConditions">{date}</Trans>}</DownloadButton></div>;
        })}</OldDocumentsToggle></div>;
    $[45] = locale;
    $[46] = t;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== props || $[49] !== t1 || $[50] !== t17 || $[51] !== t21 || $[52] !== t22 || $[53] !== t4 || $[54] !== t6) {
    t23 = <DocumentSection title={t1} icon={t2} {...props}>{t4}{t6}{t17}{t21}{t22}</DocumentSection>;
    $[48] = props;
    $[49] = t1;
    $[50] = t17;
    $[51] = t21;
    $[52] = t22;
    $[53] = t4;
    $[54] = t6;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  return t23;
}